<template>
	<b-container id="lists-vendor-detail" v-if="$can('view-vendor-details') || $can('view-all')" fluid>
		<b-row class="page-title">
            <b-container fluid>
                <b-row>
                    <b-col>
                        <h3>Vendor Detail:</h3>
                        <span style="text-indent: 20px;" v-if="row"><h5>{{ row.name }}</h5></span>
                    </b-col>
                    <b-col class="text-right">
                        <b-button variant="outline-secondary" size="lg" @click="openModal('edit-vendor', row)">Edit</b-button>
                        <b-dropdown id="dropdown-new-transaction" text="New Transaction" variant="success" size="lg" class="m-2" right>
                            <b-dropdown-item to="/purchasing/bills/create">Bill</b-dropdown-item>
                        </b-dropdown>
                    </b-col>
                </b-row>
                <hr>
            </b-container>
        </b-row>
        <b-row>
            <b-container fluid>
                <b-card no-body>
                    <b-tabs card>
                        <b-tab title="Transaction List" active>
                            <b-card-text>
                                <b-row class="row-transactions-table">
                                    <b-container fluid>
                                        <b-table
                                            :key="tables.transactions.key"
                                            class="transactions-table"
                                            responsive bordered
                                            hover no-border-collapse
                                            sticky-header="600px"
                                            head-variant="light"
                                            :items="tables.transactions.items" :fields="tables.transactions.fields"
                                            :sort-by="tables.transactions.sortBy"
                                            :sort-desc="tables.transactions.sortDesc"
                                            :per-page="tables.transactions.perPage"
                                            :current-page="tables.transactions.currentPage"
                                            :filter="tables.transactions.filter"
                                            @filtered="onFiltered"
                                            :busy="tables.transactions.isBusy"
                                        >
                                            <template v-slot:cell(id)="row">
                                                <span v-if="row.item.type == 'Bill'"><b-link :to="{name: 'BillsDetail', params: { billNum: row.item.reference_number, vendorName: row.name } }">{{ row.item.id }}</b-link></span>
                                                <span v-else>{{ row.item.id }}</span>
                                            </template>

                                            <template v-slot:cell(amount)="row">
                                                <span v-if="row.item.amount && row.item.type == 'Bill'">{{ row.item.amount }}</span>
                                            </template>

                                            <template v-slot:cell(date)="row">
                                                {{ row.item.date | moment('MM-DD-YYYY') }}
                                            </template>
                                        </b-table>
                                    </b-container>
                                </b-row>

                                <b-row>
                                    <b-col cols="6">
                                        {{ pageTotals }}
                                    </b-col>

                                    <b-col cols="6" class="my-1">
                                        <b-pagination
                                            v-model="tables.transactions.currentPage"
                                            :total-rows="tables.transactions.totalRows"
                                            :per-page="tables.transactions.perPage"
                                            align="fill"
                                            size="sm"
                                            class="my-0"
                                            >
                                        </b-pagination>
                                    </b-col>
                                </b-row>
                            </b-card-text>
                        </b-tab>

                        <b-tab title="Vendor Details">
                            <b-card-text>
                                <b-row>
                                    <b-col>
                                        <b-table-simple hover small responsive bordered>
                                            <b-tbody>
                                                <b-tr>
                                                    <b-td><strong>Vendor</strong></b-td>
                                                    <b-td>{{ row.name }}</b-td>
                                                </b-tr>
                                                <b-tr>
                                                    <b-td><strong>Email</strong></b-td>
                                                    <b-td>{{ row.email }}</b-td>
                                                </b-tr>
                                                <b-tr>
                                                    <b-td><strong>Phone</strong></b-td>
                                                    <b-td>{{ row.phone }}</b-td>
                                                </b-tr>
                                                <b-tr>
                                                    <b-td><strong>Mobile</strong></b-td>
                                                    <b-td></b-td>
                                                </b-tr>
                                                <b-tr>
                                                    <b-td><strong>Fax</strong></b-td>
                                                    <b-td>{{ row.fax }}</b-td>
                                                </b-tr>
                                                <b-tr>
                                                    <b-td><strong>Other</strong></b-td>
                                                    <b-td></b-td>
                                                </b-tr>
                                                <b-tr>
                                                    <b-td><strong>Website</strong></b-td>
                                                    <b-td>{{ row.website }}</b-td>
                                                </b-tr>
                                                <b-tr>
                                                    <b-td><strong>Notes</strong></b-td>
                                                    <b-td></b-td>
                                                </b-tr>
                                            </b-tbody>
                                        </b-table-simple>
                                    </b-col>
                                    <b-col>
                                        <b-table-simple hover small responsive bordered>
                                            <b-tbody>
                                                <b-tr>
                                                    <b-td><strong>Billing Address</strong></b-td>
                                                    <b-td>
                                                        <span v-if="row.billing_address_1">{{ row.billing_address_1 }}</span>
                                                        <span v-if="row.billing_address_2"><br />{{ row.billing_address_2 }}</span>
                                                        <span v-if="row.billing_city"><br />{{ row.billing_city }}</span>
                                                        <span v-if="row.billing_state">, {{ row.billing_state }}</span>
                                                        <span v-if="row.billing_postal_code">{{ row.billing_postal_code }}</span>
                                                        <span v-if="row.billing_country"><br />{{ row.billing_country }}</span>
                                                    </b-td>
                                                </b-tr>
                                                <b-tr>
                                                    <b-td><strong>Shipping Address</strong></b-td>
                                                    <b-td>
                                                        <span v-if="row.shipping_address_1">{{ row.shipping_address_1 }}</span>
                                                        <span v-if="row.shipping_address_2"><br />{{ row.shipping_address_2 }}</span>
                                                        <span v-if="row.shipping_city"><br />{{ row.shipping_city }}</span>
                                                        <span v-if="row.shipping_state">, {{ row.shipping_state }}</span>
                                                        <span v-if="row.shipping_postal_code">{{ row.shipping_postal_code }}</span>
                                                        <span v-if="row.shipping_country"><br />{{ row.shipping_country }}</span>
                                                    </b-td>
                                                </b-tr>
                                                <b-tr>
                                                    <b-td><strong>Terms</strong></b-td>
                                                    <b-td></b-td>
                                                </b-tr>
                                                <b-tr>
                                                    <b-td><strong>Payment Method</strong></b-td>
                                                    <b-td></b-td>
                                                </b-tr>
                                                <b-tr>
                                                    <b-td><strong>Delivery Method</strong></b-td>
                                                    <b-td></b-td>
                                                </b-tr>
                                            </b-tbody>
                                        </b-table-simple>
                                    </b-col>
                                </b-row>
                            </b-card-text>
                        </b-tab>
                    </b-tabs>
                </b-card>
            </b-container>
        </b-row>

        <modal-edit-vendor
            v-if="modals['edit-vendor'].active"
            :row="row"
            @getRow="getRow"
        />
	</b-container>
</template>

<script>
    import Treeselect from '@riophae/vue-treeselect'
    import ModalEditVendor from './modals/EditVendor'
	export default {
		name: 'vendorDetail',

        metaInfo() {
            return {
                title: 'Vendor - ' + this.row.name,
            }
        },

		props: [ 'id' ],

		components: {
            Treeselect,
            'modal-edit-vendor': ModalEditVendor
		},

		data() {
            return {
                row: [],

                tables: {
                    transactions: {
                        isBusy: false,
                        totalRows: 1,
                        currentPage: 1,
                        perPage: 20,
                        pageOptions: [20, 50, 100, 500, 1000],
                        sortBy: 'date',
                        sortDesc: true,
                        filter: null,
                        key: 1,
                        fields: [
                            {
                                key: 'id',
                                label: 'ID',
                                sortable: true
                            },
                            {
                                key: 'status',
                                label: 'Status',
                                sortable: true
                            },
                            {
                                key: 'date',
                                label: 'Date',
                                sortable: true
                            },
                            {
                                key: 'type',
                                label: 'Type',
                                sortable: true
                            },
                            {
                                key: 'reference_number',
                                label: 'Reference #',
                                sortable: true
                            },
                            // {
                            //     key: 'applied_to',
                            //     label: 'Applied To',
                            //     sortable: true
                            // },
                            {
                                key: 'amount',
                                label: 'Amount',
                                sortable: true
                            },
                            {
                                key: 'balance',
                                label: 'Balance',
                                sortable: true
                            },
                            {
                                key: 'actions',
                                label: '',
                                thClass: 'vendors-table-style-actions'
                            }
                        ],
                        items: []
                    }
                },

                modals: {
                    'edit-vendor': {
                        active: 0
                    }
                }
            }
        },

        methods: {
            openModal(modalName, row, extra) {
                let prefix = 'modal-lists-vendors-'
                switch (modalName) {
                    case 'edit-vendor':
                        this.modals[modalName].active = 1

                        break;
                }

                this.$nextTick(() => {
                    this.$bvModal.show(prefix + modalName)
                })
            },

            closeModal(modalName) {
                this.$bvModal.hide(modalName)
            },

            getRow() {
                let url = 'api/lists/vendors/getvendor/' + this.id
                axios.get(url, {})
                .then((res) => {
                    this.row = res.data.vendor
                }, () => {
                    this.has_error = true
                })
            },

            onFiltered(filteredItems) {
                this.tables.transactions.totalRows = filteredItems.length
                this.tables.transactions.currentPage = 1
            },

            getTransactions(silent) {
                if (!silent) {
                    this.toggleBusy()
                }

                let url = 'api/lists/vendors/gettransactions/' + this.id
                axios.get(url, {})
                .then((res) => {
                    this.tables.transactions.items = res.data.transactions
                    this.tables.transactions.totalRows = this.tables.transactions.items.length

                    if (!silent) {
                        this.toggleBusy()
                    }
                }, () => {
                    this.has_error = true
                })
            },

            toggleBusy() {
                this.tables.transactions.isBusy = !this.tables.transactions.isBusy
            }
        },

        computed: {
            pageTotals() {
                let totalRows = this.tables.transactions.totalRows
                let currentPage = this.tables.transactions.currentPage
                let perPage = this.tables.transactions.perPage

                let from
                let to

                if (perPage > totalRows) {
                    from = 1
                    to = totalRows
                } else {
                    to = perPage * currentPage
                    from = to - perPage + 1
                }

                return 'Showing ' + from + ' to ' + to + ' of ' + this.tables.transactions.totalRows + ' rows'
            }
        },

        mounted() {
            this.getRow()
            this.getTransactions()

        	this.$root.$on('bv::modal::hidden', (bvEvent, modalId) => {
                switch (modalId) {
                    case 'modal-lists-vendors-edit-vendor':
                        this.modals['edit-vendor'].active = 0

                        break;
                }
            })
        }
	}
</script>

<style lang="scss">
	#lists-vendor-detail {

	}
</style>
